if (!customElements.get('mj-artist-directory')) {
  customElements.define('mj-artist-directory', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const input = this.querySelector('input');
      const clear = this.querySelector('.mj-artists-clear');
      const buttons = [...this.querySelectorAll('[data-letter]')];
      const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleUpperCase().trim();
      const cards = [...this.querySelectorAll('[data-name]')].map(element => ({ element, name: normalize(element.dataset.name) }));
      let letter = 'all';
      const update = () => {
        const query = normalize(input.value);
        let count = 0;
        cards.forEach(({ element, name }) => {
          const starts = letter === 'all' || (letter === '#' ? /^[0-9]/.test(name) : name.startsWith(letter));
          const visible = starts && name.includes(query);
          element.hidden = !visible;
          if (visible) count++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.letter === letter)));
        clear.hidden = !query && letter === 'all';
        this.querySelector('.mj-artists-empty').hidden = count !== 0;
        this.querySelector('.mj-artists-count').textContent = count === 1 ? this.dataset.one : this.dataset.count.replace('[count]', count);
      };
      input.addEventListener('input', () => { letter = 'all'; update(); }, options);
      input.addEventListener('search', () => { letter = 'all'; update(); }, options);
      buttons.forEach(button => button.addEventListener('click', () => {
        letter = button.dataset.letter;
        input.value = '';
        update();
      }, options));
      clear.addEventListener('click', () => { input.value = ''; letter = 'all'; update(); input.focus(); }, options);
      this.querySelector('.mj-artists-controls').hidden = false;
      update();
    }
    disconnectedCallback() { this.abort.abort(); }
  });
}
